module.exports = __webpack_public_path__ + "static/media/bonnier.bb03979f.svg";